export interface Query {
    Paging?: { Page: number, PageSize: number }
    Sort?: { field: string, order: "desc" | "asc" }
    Exclude?: string | string[]
    Include?: string | string[]
    Expand?: string | string[]
    Where?: { kind: "search" | "equals" | "notEquals" | "contains" | "startsWith" | "endsWith" | "exists", field: string, value?: string, rel?: string }[]
  }

  function ArrayToString(s: string | string[]): string {
    return Array.isArray(s) ? s.join(';') : s
  }

  export function ConvertQuery(query: Query): GCQuery {
    let q: GCQuery = {} as GCQuery
    if (query.Paging) { q.Page = query.Paging.Page; q.PageSize = query.Paging.PageSize }
    if (query.Sort) q.Sort = query.Sort.order === 'desc' ? '-' + query.Sort.field : query.Sort.field
    if (query.Exclude) q.Exclude = ArrayToString(query.Exclude)
    if (query.Include) q.Include += ArrayToString(query.Include)
    if (query.Where) q.Where = query.Where.map(w => { return { Kind: w.kind, Field: w.field, Value: w.value ?? '' } })
    return q
  }

  export function FixQuery(query: Query): Query {
    if (!query.Where) query.Where = []
    return query
  }

  // In the future, we might want to use this for flatter queries
  export interface GCQuery {
    Page: number
    PageSize: number
    Sort: string
    Exclude: string
    Include: string
    Where: Where[]
}

interface Where {
  Kind: string,
  Field: string,
  Value: string
}